export const PRODUCT_UPLOAD_INFO_REQUESTED = "PRODUCT_UPLOAD_INFO_REQUESTED";
export const PRODUCT_UPLOAD_INFO_RECEIVED = "PRODUCT_UPLOAD_INFO_RECEIVED";
export const PRODUCT_UPLOAD_INFO_REQUEST_FAILED = "PRODUCT_UPLOAD_INFO_REQUEST_FAILED";

export const requestProductUploadInfo = (accountId, uploadId) => ({
  type: PRODUCT_UPLOAD_INFO_REQUESTED,
  accountId: accountId,
  id: uploadId
});

export const receiveProductUploadInfo = (uploadId, result) => ({
  type: PRODUCT_UPLOAD_INFO_RECEIVED,
  id: uploadId,
  payload: result
});
